import { BrowserModule } from '@angular/platform-browser';
import {NgModule, Provider} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {CommonModule} from '@angular/common';
import {CookieService} from 'ngx-cookie-service';
import { LoginComponent } from './login/login.component';
import {FormsModule} from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {MatSliderModule} from '@angular/material/slider';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatIconModule} from '@angular/material/icon';
import {AuthInterceptor} from './shared/auth.interceptor';
import {AuthGuard} from './service/auth.guard';
import {AlertService} from './service/alert.service';
import {AuthService} from './service/auth.service';
import {FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule} from 'angularx-social-login';

const INTERCEPTOR_PROVIDER: Provider={
  provide: HTTP_INTERCEPTORS,
  multi: true,
  useClass: AuthInterceptor
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    TooltipModule.forRoot(),
    FormsModule,
    NgbModule,
    FontAwesomeModule,
    MatSliderModule,
      SocialLoginModule,
      MatIconModule,
    AppRoutingModule,
    BrowserAnimationsModule//, ServiceWorkerModule.register('ngsw-worker.js')
  ],
  exports: [CommonModule],
  providers: [CookieService,
    INTERCEPTOR_PROVIDER,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
                `${environment.googleId}`
            )
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(`${environment.facebookID}`)
          }
        ]
      } as SocialAuthServiceConfig,
    },
    AuthService,
    AuthGuard,
    AlertService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
